import axios from 'axios'
import { Toast } from 'vant';
import store from '../store'
axios.defaults.timeout = 5000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json';        //配置请求头
axios.defaults.headers.post['XX-Device-Type'] = 'mobile'; 
// axios.defaults.baseURL = 'http://insure.yklmartspace.com/public/api/home/';   //配置接口地址
axios.defaults.baseURL = store.state.baseURL;   //测试地址
// axios.defaults.baseURL  = '/apis/api/home/';
//POST传参序列化(添加请求拦截器)
/*axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    if(config.method  === 'post'){
        config.data = qs.stringify(config.data);
    }
    return config;
},(error) =>{
    console.log('错误的传参')
    return Promise.reject(error);
});*/

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    console.log('返回状态判断')
    console.log(res)
    if(!res.data.success){
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    console.log('网络异常')
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url,params,headers) {
    return new Promise((resolve, reject) => {
        axios.post(url,params,headers)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
const https={
    fetchPost,
    fetchGet,
}
export default {
    fetchPost,
    fetchGet,
}


// WEBPACK FOOTER //
// ./src/utils/https.js